import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { ReasonCodeMaintenanceApiService } from '../../../../../../modules/api/reason-code-maintenance-api.service';

import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';

@Component({
   templateUrl: './add-reason-code-modal.template.html'
})
export class AddReasonCodeModalComponent {
   loading = false;

   form = new UntypedFormGroup({
      reasonCode: new UntypedFormControl('', [Validators.required, Validators.maxLength(10)]),
      area: new UntypedFormControl(''),
      description: new UntypedFormControl(''),
      designLateFinish: new UntypedFormControl(false),
      constLateFinish: new UntypedFormControl(false),
      definitions: new UntypedFormControl(''),
      active: new UntypedFormControl(true)
   });

   constructor(
      private readonly toastr: ToastrService,
      public readonly dialogRef: MatDialogRef<AddReasonCodeModalComponent>,
      private readonly reasonCodeMaintenanceApiService: ReasonCodeMaintenanceApiService,
   ) { }

   onSaveClick() {
      this.loading = true;
      const body = this.form.value;
      body.reasonCode = body.reasonCode.toUpperCase();

      this.reasonCodeMaintenanceApiService.createReasonCode(body)
         .pipe(finalize(() => this.loading = false))
         .subscribe(
            response => {
               this.toastr.success(`Successfully added reason code ${this.form.get('reasonCode').value}`);
               this.dialogRef.close(response);
            }
         );
   }
}
